import type { InspectionSeverity } from "./InspectionFinding";

export const questionTypeOptions = {
  boolean_question: "Ja/Nee vraag",
  multi_question: "Meerkeuze vraag",
  non_question: "Tekstregel",
  value_question: "Open vraag (numeriek)",
  text_question: "Open vraag (tekst)",
  gps_question: "Locatie vraag (GPS)",
  logic_boolean_question: "Automatische waarde (ja/nee)",
  logic_value_question: "Automatische waarde (numeriek)",
  logic_multiscore_first_question: "Automatische waarde (multi-case, eerste)",
  logic_multiscore_sum_question: "Automatische waarde (multi-case, som)",
  logic_value_score_question: "Automatische waarde (waarde ref. als score)",
};
export type QuestionType = keyof typeof questionTypeOptions;

/** The value of a single answer to a question, as sent to/received from `inspections/{id}/results`. */
export type QuestionAnswerValue = boolean | number | string | null;

export class MultiQuestionOption {
  constructor(
    public readonly label: { [language: string]: string },
    public readonly score: number,
    public readonly abort: boolean,
    public readonly generatesFinding: boolean,
    public readonly allowedFindingSeverities: InspectionSeverity[],
  ) {}

  static fromJson(json: any): MultiQuestionOption {
    return new MultiQuestionOption(
      json["label"],
      json["score"],
      json["abort"] ?? false,
      json["generates_finding"] ?? false,
      json["allowed_finding_severities"] ?? [],
    );
  }
}

export class Question {
  constructor(
    public readonly id: string,
    public readonly questionSetId: string,
    public readonly type: QuestionType,
    public readonly header: { [language: string]: string },
    public readonly number: string,
    public readonly displayCategory: string | null,
    public readonly scoreCategory: string | null,
    public readonly description: { [language: string]: string },
    public readonly shortDescription: string | null,
    public readonly order: number,
    public readonly hide: boolean,
    public readonly options: MultiQuestionOption[] | null,
  ) {}

  static fromJson(json: any): Question {
    const properties = json["properties"] ?? {};
    return new Question(
      json["id"],
      json["question_set_id"],
      json["type"],
      json["header"],
      json["number"],
      json["display_category"],
      json["score_category"],
      json["description"],
      json["short_description"],
      json["order"] ?? 0,
      json["hide"] ?? false,
      properties["options"]
        ? properties["options"].map((option: any) => MultiQuestionOption.fromJson(option))
        : null,
    );
  }
}
